import type { RecentSmartViewArtifact } from "../../../../../api/types/smartViewArtifactsTypes";
import type { ArtifactRow } from "./artifactRow";

export interface RecentArtifactTile {
  row: ArtifactRow;
  openedAt: string;
}

export const getRecentArtifactTiles = (
  recent: RecentSmartViewArtifact[],
  rows: ArtifactRow[]
): RecentArtifactTile[] => {
  const rowsById = new Map(rows.map((row) => [row.id, row]));
  return recent.flatMap(({ id, openedAt }) => {
    const row = rowsById.get(id);
    return row ? [{ row, openedAt }] : [];
  });
};
